import Attach2 from '@crehana/compass.icons.outline/Attach2';
import Clock from '@crehana/compass.icons.outline/Clock';
import People from '@crehana/compass.icons.outline/People';
import Smartphone from '@crehana/compass.icons.outline/Smartphone';
import {
  COURSE_LEVEL_ICON_MAP_COMP,
  type TCOURSE_LEVEL,
} from '@crehana/compass.knowledgehub';
import cn from 'clsx';

import { useCourseDetailTranslation } from '../../../hooks';
import GridResumeCell from './GridResumeCell';

type TGridResumeProps = {
  duration: string;
  level: string;
  students?: number;
  attachments?: number;
  accessByApp?: boolean;
  updatedAt?: string;
  className?: string;
};

const GridResume: React.FC<TGridResumeProps> = ({
  attachments = 0,
  students = 0,
  level,
  duration,
  accessByApp,
  updatedAt,
  className,
}) => {
  const { t } = useCourseDetailTranslation();
  const shouldRenderLevel = !!level;
  const shouldRenderAttachments = attachments > 0;
  const shouldRenderStudents = students > 15;
  const shouldRenderUpdatedAt = !!updatedAt;

  return (
    <section
      className={cn(
        // Border
        'tw-border-b tw-border-solid tw-border-neutral-light-400 sm:tw-border-transparent',
        // Padding
        'tw-pb-2 sm:tw-pb-0',
        className,
      )}
    >
      <h3 className="tw-font-subtitle4 tw-mb-1.2">{t('INFO_SECTION_TITLE')}</h3>

      <div
        className={cn(
          'tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-0.8',
          shouldRenderUpdatedAt && 'tw-tw-mb-1.6',
        )}
      >
        <GridResumeCell
          title={t('TOTAL_DURATION')}
          icon={Clock}
          value={duration}
        />
        {shouldRenderLevel && (
          <GridResumeCell
            title={t('LEVEL_LABEL')}
            icon={
              COURSE_LEVEL_ICON_MAP_COMP[
                level.toLowerCase() as TCOURSE_LEVEL
              ] || COURSE_LEVEL_ICON_MAP_COMP.intermedio
            }
            value={level}
          />
        )}
        {shouldRenderAttachments && (
          <GridResumeCell
            title={t('TOTAL_ATTACHMENTS_TEXT')}
            icon={Attach2}
            value={attachments.toLocaleString('es-ES', { style: 'decimal' })}
          />
        )}
        {shouldRenderStudents && (
          <GridResumeCell
            title={t('STUDENTS')}
            icon={People}
            value={students.toLocaleString('es-ES', { style: 'decimal' })}
          />
        )}
        {accessByApp && (
          <GridResumeCell title={t('ACCESS_TEXT')} icon={Smartphone} />
        )}
      </div>

      {shouldRenderUpdatedAt && (
        <span className="tw-font-body4 tw-text-neutral-light-700 tw-mt-2 tw-block">
          {t('UPDATED_AT')} <time>{updatedAt}</time>
        </span>
      )}
    </section>
  );
};

export default GridResume;
